import dayjs, { Dayjs } from 'dayjs';

export const API_DATE_FORMAT = 'YYYY-MM-DD';

// Data da API (ISO ou "YYYY-MM-DD") para o valor do DatePicker; vazio ou inválido vira null
export function toDayjs(value?: string | null): Dayjs | null {
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
}

// Valor do DatePicker para a API; limpo ou digitação incompleta vira null
export function toApiDate(value?: Dayjs | null): string | null {
    return value && value.isValid() ? value.format(API_DATE_FORMAT) : null;
}

// O valor externo só substitui o interno quando representa outra data (evita apagar a digitação em andamento)
export function shouldSyncDate(inner: Dayjs | null, value?: string | null): boolean {
    return toApiDate(inner) !== toApiDate(toDayjs(value));
}

// Converte a data da API para o valor do <input type="date"> (YYYY-MM-DD)
export function toDateInputValue(value?: string | null): string | undefined {
    return toDayjs(value)?.format(API_DATE_FORMAT);
}

// Converte a data da API para o valor do <input type="datetime-local"> (YYYY-MM-DDTHH:mm)
export function toDateTimeInputValue(value?: string | null): string | undefined {
    return toDayjs(value)?.format('YYYY-MM-DDTHH:mm');
}

// Reenvia a data original (com hora) quando o dia não foi alterado, para não zerar o horário gravado
export function resolveDateValue(inputValue?: string, original?: string): string | undefined {
    if (!inputValue) return undefined;
    return original && toDateInputValue(original) === inputValue ? original : inputValue;
}

export function formatDate(value?: string | null, format = 'DD/MM/YYYY'): string {
    return toDayjs(value)?.format(format) ?? '';
}

export function formatDateTime(value?: string | null): string {
    return formatDate(value, 'DD/MM/YYYY HH:mm');
}
